export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_VIEW_AS_ROLE = 'SET_VIEW_AS_ROLE'
export const SET_VIEW_AS_USER = 'SET_VIEW_AS_USER'
export const START_LOADING = 'START_LOADING'
export const FINISH_LOADING = 'FINISH_LOADING'